<template>
  <div class=" is-fullwidth">
    <div class="  ">
        <div class="columns ">
          <div class="column">
           
          </div>
          <div class="column is-one-fifth">
            <button class="button is-light">{{filteredOrders.length}} orders / {{ this.totalGarments}} garments</button>
          </div>
          <div class="column is-one-fifth">
        <input class="input " v-model="search" placeholder="search orders ..."/>
          </div>
          
           
          </div>
          <br />
    </div>

    <div class="notification is-primary" v-if="loading == true">
                Loading orders ...
            </div>
    
            <div class="notification is-warning" v-if="loading == false && filteredOrders.length == 0">
                There are no orders to show
            </div>
   
    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" v-if="loading == false && filteredOrders.length > 0">
    	<thead>
    		<th width="60">&nbsp;</th>
        <th>PO Number</th>
   	 		<th>Customer</th>
          <th>Garment</th>
          <th @click="updateSortOrder('orderdate')" style="cursor:pointer">Ordered
            <span v-if="order_by === 'orderdate DESC'">&#8595;</span>
            <span v-if="order_by === 'orderdate ASC'">&#8593;</span>
          </th>
          <th @click="updateSortOrder('deliverydate')" style="cursor:pointer">Delivery
            <span v-if="order_by === 'deliverydate DESC'">&#8595;</span>
            <span v-if="order_by === 'deliverydate ASC'">&#8593;</span>
          </th>
          <th>Qty</th>
          <th>Makeup</th>
          
    	</thead>
    	<tbody>
		    
            
            <tr v-for="order in filteredOrders" v-bind:key="order.orderID">
         <td >
                  <a :href="ASP_URL + '/printorder.asp?txtPONumber=' + order.ponumber" target="_blank"><button class="button is-small is-info" :disabled="working===true" >Print</button></a>
              </td>
               <td ><a :href="'/orders/order-search?ponumber=' + order.ponumber" target="_blank">{{order.ponumber}}</a></td>
          <td>{{order.clientname}}</td>
          <td>{{order.garmentname}}</td>
          <td>{{order.orderdate}}</td> 
          <td>{{order.deliverydate}}</td>
          <td>{{ order.total_qty }}</td>
          <td>
            <span v-if="order.ireland==1">Ireland / {{ order.makeup_location_name }}</span>
            <span v-if="order.offshore==1">Offshore / {{  order.makeup_location_name }}</span>
          </td>

          
              
			</tr>
    	</tbody>
    </table>


    
    
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import UtilityService from '@/services/UtilityService.js';

import OrderMixin from "@/mixins/OrderMixin.js";

export default {
  components: {
    
  },
  mixins: [OrderMixin],
  data() {
    return {
       errors: [],
      orders: [],
      showDespatchModal: false,
      selectedOrder: 0,
      working :false,
      loading: true,
      ASP_URL : process.env.VUE_APP_ASP_URL,
      ranges: [],
      makeuplocations: [],
      order_by: 'deliverydate DESC',
      makeup_location_id: '',
      showAddButtons: true,
      accessToken: '',
      
      search:'',
      tabToView: 'new',
      user: {tasks: []},
      
    }
  },
   methods: {
    capitalize(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
     
    
    
    
      async getOrders() {
        this.loading=true
        this.orders = []
        OrderService.getHatOrdersCompleted(this.accessToken, this.order_by)
        .then(
          (orders => {
            this.$set(this, "orders", orders);
            this.loading=false
          }).bind(this)
        );
      },
      
    
  },
  computed : {
      filteredOrders: function () {
        // let filteredOrders = []
          //let filteredOrders = this.orders
          let filteredOrders =  this.orders

            if(this.search != '' && this.search != null)
            {
              filteredOrders = filteredOrders.filter(row => row.ponumber.toLowerCase().includes(this.search.toLowerCase()) || row.garmentname.toLowerCase().includes(this.search.toLowerCase()) || row.clientname.toLowerCase().includes(this.search.toLowerCase()))
            }

           filteredOrders = filteredOrders.filter(row =>  row.status == "COMPLETED")

            return filteredOrders
        
      },
      totalGarments() {
        return this.filteredOrders.reduce((sum, order) => sum + (order.total_qty || 0), 0);
      }
  },

  // Fetches posts when the component is created.
  created() {
     this.getAccessToken()
        .then(() => { 
           this.getOrders();
           this.getUserProfile();
        });
  },
 
  mounted() {
    /*if (localStorage.production_allocated_makeup_location_id) {
      this.makeup_location_id = localStorage.production_allocated_makeup_location_id;
    }
    else{
      this.makeup_location_id = 5
    }*/
      
  },
  watch: {
   tabToView: function () {
      if(this.tabToView == "new")
      {
        this.getOrders()
      }
    },
  }
}


</script>

